import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import Topnav from '../../components/adminNav/Topnav'
import OrderDetails from '../../components/order/OrderDetails';
import Sidebar from '../../components/sidebar/Sidebar'
import { BASE_URL } from '../../requestMethod';

export default function Orders() {
    const user = useSelector((state) => state.user.currentUser);
    const trackBasket = useSelector((state) => state.track);
    const [baskets, setAllBasket] = useState([]);
    const [order, setOrder] = useState({});

    useEffect(() => {
        const getBaskets = async () => {
            try {
                const res = await axios.get(`${BASE_URL}Basket/vendorOrders?page=0`, {
                    mode: 'no-cors',
                    headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
                })
                setAllBasket(res.data.returnObj);
                setOrder(res.data.returnObj[0])
            }
            catch (err) {
                console.log(err)
            }
        }
        getBaskets();
    }, []);

    const orderDetail = (item) => {
        setOrder(item);
    }

    const HandleTracking = ({ status }) => {
        //trackBasket.track;
        console.log(status)
        return (
            status === 0 ? (<label className="badge badge-danger">Pending</label>) :
                status === 1 ? (<label className="badge badge-dark">We are in Market</label>) :
                    status === 2 ? (<label className="badge badge-warning">Packaging</label>) :
                        status === 3 ? (<label className="badge badge-info">On Transit</label>) :
                            status === 4 ? (<label className="badge badge-primary">Ready to be Picked</label>) :
                                status === 5 ? (<label className="badge badge-success">Delivered</label>) :
                                    (<label className="badge badge-success">Treated</label>)

        )

    }
    return (
        <div className="container-scroller">
            <Topnav />
            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="content-wrapper">
                    <div className="page-header">
                        <h3 className="page-title"> All Orders </h3>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="#"></a></li>
                            </ol>
                        </nav>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Orders</h4>
                                    <div className="table-responsive">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    {/* <th>Transaction Number</th> */}
                                                    <th>Payment Status</th>
                                                    <th>Treated Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {baskets ?
                                                    baskets.map((item) => (
                                                        <tr onClick={() => orderDetail(item)} style={{ cursor: "pointer" }} key={item.id}>
                                                            <td>{item.customerName}</td>
                                                            {/* <td>{item.transactionNumber}</td> */}
                                                            <td>
                                                                {item.paymentStatus === 1 ? (
                                                                    <label className="badge badge-success">Paid</label>
                                                                ) : (<label className="badge badge-danger">Pending</label>)}

                                                            </td>
                                                            <td>{<HandleTracking status={item.track} />}</td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan={3}>No orders yet!</td>
                                                        </tr>
                                                    )}


                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 grid-margin stretch-card">
                            <OrderDetails order={order} />
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}
